import * as React from "react";
import type { SVGProps } from "react";
const SvgStar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17.28 22c-.37 0-.74-.12-1.06-.35L12 18.58l-4.22 3.07a1.8 1.8 0 0 1-2.13 0c-.63-.47-.87-1.24-.62-1.98l1.79-5.21-4.01-2.6c-.66-.43-.96-1.22-.74-1.97.22-.76.91-1.27 1.72-1.27h4.65l1.87-5.43c.25-.73.92-1.2 1.69-1.2.77 0 1.44.47 1.69 1.2l1.87 5.43h4.65c.8 0 1.49.51 1.72 1.27.22.75-.08 1.54-.74 1.97l-4 2.59 1.79 5.21c.25.74.01 1.51-.62 1.98-.32.24-.7.36-1.07.36h-.01ZM12 16.54c.37 0 .74.12 1.06.35l3.79 2.75-1.62-4.72c-.26-.76.03-1.6.71-2.04l3.48-2.25h-4.01c-.77 0-1.45-.48-1.69-1.2l-1.72-5-1.72 5c-.25.72-.93 1.2-1.69 1.2H4.58l3.48 2.25c.68.44.98 1.28.71 2.04l-1.62 4.72 3.79-2.75c.32-.23.69-.35 1.06-.35Z"
    />
  </svg>
);
export default SvgStar;
